"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityType = void 0;
exports.ActivityType = ['sub', 'pgw', 'igw', 'xgw', 'task', 'human', 'serv', 'send', 'receive', 'manual', 'busin', 'script', 'call',
    'inthrow', 'inmcatch', 'inmthrow', 'intimer', 'inescal', 'incond', 'incomp', 'inscatch', 'insthrow'
];
//# sourceMappingURL=SharedTypes.js.map